import { render, staticRenderFns } from "./CheckoutCard.vue?vue&type=template&id=5c395644&scoped=true&"
import script from "./CheckoutCard.vue?vue&type=script&lang=js&"
export * from "./CheckoutCard.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CheckoutCard.vue?vue&type=style&index=1&id=5c395644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c395644",
  null
  
)

export default component.exports